export const tourCustomerRoute = "tour-customer";
export const landingTour = `/${tourCustomerRoute}/landing-tour`;
export const tourListing = `/${tourCustomerRoute}/tour-listing`;
export const compareTour = `/${tourCustomerRoute}/compare-tour`;
export const tourDetails = `/${tourCustomerRoute}/tour-details`;
export const tourGallery = `/${tourCustomerRoute}/tour-gallery`;
export const operatorDetails = `/${tourCustomerRoute}/operator-details`;
export const tourPartner = `/${tourCustomerRoute}/tour-partner`;
export const tourPayment = `/${tourCustomerRoute}/tour-payment`;
export const tourReviews = `/${tourCustomerRoute}/tour-reviews`;
export const tourBooking = `/${tourCustomerRoute}/tour-booking`;
export const tourBookingDetails = `/${tourCustomerRoute}/tour-booking-details`;
export const tourPaymentSuccess = `/${tourCustomerRoute}/payment-success`;
export const tourPaymentUnsuccessful = `/${tourCustomerRoute}/payment-unsuccessful`;
export const tourbookingSuccess = `/${tourCustomerRoute}/booking-success`;
export const tourBookingUnsuccessful = `/${tourCustomerRoute}/booking-unsuccessful`;
export const tourBookingfailed = `/${tourCustomerRoute}/booking-failed`;
export const tourCustomerBookingDetails = `/${tourCustomerRoute}/booking-details`;
export const cancelRider = `/${tourCustomerRoute}/cancel-rider`;
export const cancelRidePerson = `/${tourCustomerRoute}/cancel-ride-person`;
export const bookingCancellation = `/${tourCustomerRoute}/booking-cancellation`;
export const tourAddReview = `/${tourCustomerRoute}/tour-add-review`;
export const reviewSubmit = `/${tourCustomerRoute}/review-submit`;
export const bookingCancellationDetails = `/${tourCustomerRoute}/booking-cancellation-details`;
export const tourInquiry = `/${tourCustomerRoute}/tour-inquiry`;
export const tourEmptyCart = `/${tourCustomerRoute}/emptycart`;
export const tourAddRating = `/${tourCustomerRoute}/add-rating`;
export const tourAddReviewInv = `/${tourCustomerRoute}/add-review`;
